import {Platform, StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
    paddingHorizontal: 5,
  },

  headerText: {
    fontSize: 17,
    fontWeight: '500',
    flexShrink: 1,
  },

  headerEditButton: {
    backgroundColor: '#2C2C2C',
    borderRadius: 20,
    paddingHorizontal: 16,
    paddingVertical: 8,
    minWidth: 85,
    minHeight: 44,
    borderWidth: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },

  headerEditText: {
    color: white,
    fontWeight: '600',
    fontSize: 14,
  },

  goBackIcon: {
    marginLeft: -10,
  },
  scrollViewBase: {
    flex: 1,
  },
  content: {
    paddingHorizontal: 24,
    paddingBottom: 80,
  },
  section: {
    marginTop: 36,
  },
  sectionTitleTight: {
    marginTop: 20,
    paddingBottom: 0,
  },
  sectionLarge: {
    marginTop: 36,
  },
  avatarCircle: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: '#F0F0F0',
  },
  websiteLinkContainer: {
    paddingRight: 15,
  },
  websiteLink: {
    color: '#1D4ED8',
    fontSize: 15,
    fontWeight: '500',
  },
  noWebsiteUrl: {
    color: '#1C1C1E',
    fontSize: 16,
    fontWeight: '400',
  },
  fieldLabel: {
    fontSize: 12,
    color: '#475467',
    marginBottom: 6,
    fontWeight: '400',
    marginLeft: 4,
  },
  fieldValue: {
    fontSize: 15,
    color: '#1C1C1E',
    fontWeight: '600',
    lineHeight: 24,
  },
  placeholderText: {
    color: '#9CA3AF',
    fontWeight: '500',
    fontSize: 14,
  },
  aboutMeText: {
    fontSize: 12,
    color: '#1C1C1E',
    fontWeight: '300',
    lineHeight: 22,
    paddingRight: 10,
  },
  photoGrid: {
    flexDirection: 'row',
    gap: 16,
  },
  photoCard: {
    flex: 1,
  },
  viewPhotoCard: {
    width: '48%',
  },

  socialBtn: {
    marginTop: 16,
    borderWidth: 1,
    borderColor: '#667085',
    borderRadius: 24,
    paddingVertical: 8,
    paddingHorizontal: 24,
    alignSelf: 'flex-start',
    paddingBottom: 10,
  },
  socialBtnText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#1C1C1E',
  },
  socialList: {
    marginTop: 8,
  },
  socialItem: {
    marginBottom: 8,
    paddingRight: 8,
    alignSelf: 'stretch',
  },
  socialPlatformLabel: {
    fontSize: 14,
    marginBottom: 2,
    includeFontPadding: false,
  },
  socialUrlText: {
    fontSize: 14,
    color: '#1D4ED8',
    lineHeight: 22,
    fontWeight: '500',
    flexWrap: 'wrap',
  },
  readMoreContainer: {
    alignSelf: 'flex-end',
    marginTop: 8,
    marginRight: 10,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  readMoreText: {
    fontSize: 13,
    color: '#1C1C1E',
  },
  readMoreIcon: {
    fontSize: 20,
  },
  hiddenOverlay: {
    position: 'absolute',
    opacity: 0,
    left: 0,
    right: 0,
    zIndex: -1,
    elevation: -1,
  },
  socialInfoText: {
    marginTop: 4,
  },

  socialLinkRow: {
    marginBottom: 4,
  },

  fullScreenLoader: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  loaderContainer: {
    minHeight: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },

  profileSectionLoaderContainer: {
    minHeight: 220,
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabledSocialMediaButton: {
    opacity: 0.5,
  },

  disabledSocialMediaButtonText: {
    opacity: 0.6,
  },
  errorText: {
    fontSize: 14,
    lineHeight: 20,
    color: '#36373a',
    marginVertical: 6,
  },
  avatarFocusContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#F2F4F7',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photoFocusContainer: {
    width: '100%',
  },
  photoMock: {
    width: '100%',
    height: Platform.OS === 'web' ? 260 : 180,
    borderRadius: 12,
    backgroundColor: '#F2F2F7',
    marginTop: 8,

    resizeMode: 'cover',
  },
});
